// 检测文本溢出的自定义指令
const ellipsis = {
  bind(el, binding) {
    const content = binding.value || el.textContent;

    // 创建tooltip
    el.setAttribute("title", content);

    // 检测是否溢出
    const isOverflow = () => {
      return (
        el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
      );
    };

    // 立即检查一次
    if (isOverflow()) {
      el.style.cursor = "help";
    } else {
      el.removeAttribute("title");
    }

    // 监听窗口大小变化
    el._ellipsisResizeHandler = () => {
      if (isOverflow()) {
        el.setAttribute("title", content);
        el.style.cursor = "help";
      } else {
        el.removeAttribute("title");
        el.style.cursor = "";
      }
    };

    window.addEventListener("resize", el._ellipsisResizeHandler);
  },

  update(el, binding) {
    const content = binding.value || el.textContent;
    el.setAttribute("title", content);
  },

  unbind(el) {
    window.removeEventListener("resize", el._ellipsisResizeHandler);
  },
};

export default ellipsis;
